export default "__VITE_ASSET__NnNIgPT3__"